/* External */
import { all, fork } from "redux-saga/effects";

/* Sagas */
import allStations from "./allStations/sagas";
import chromecast from "./chromecast/sagas";
import epg from "./epg/sagas";
import globalSaga from "./global/sagas";
import homeTab from "./homeTab/sagas";
import pdp from "./pdp/sagas";
import player from "./player/sagas";
import search from "./search/sagas";
import streamsHistory from "./streamsHistory/sagas";
import user from "./user/sagas";

export default function* rootSaga() {
  yield all([fork(allStations)]);
  yield all([fork(chromecast)]);
  yield all([fork(epg)]);
  yield all([fork(globalSaga)]);
  yield all([fork(homeTab)]);
  yield all([fork(pdp)]);
  yield all([fork(player)]);
  yield all([fork(search)]);
  yield all([fork(streamsHistory)]);
  yield all([fork(user)]);
}
